// extracted by mini-css-extract-plugin
export var childrenContainer = "_d9-0";
export var virtualScrollArea = "_d9-1";